import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { PageWrapper } from './Page.styles';
import { REDIRECT_DELAY } from '../../config';
import BackButton from '../BackButton/BackButton';

const Page = ({
  background = true,
  borderTop = true,
  paddingBottom = true,
  backBtn = true,
  children,
}) => {
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRedirect(true);
    }, REDIRECT_DELAY);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (redirect) {
    return <Redirect to="/" />;
  } else {
    return (
      <PageWrapper
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        background={background}
        borderTop={borderTop}
        paddingBottom={paddingBottom}
      >
        {children}
        {backBtn && <BackButton />}
      </PageWrapper>
    );
  }
};

export default Page;
